import { render, staticRenderFns } from "./royaltySetting.vue?vue&type=template&id=6a5b370c"
import script from "./royaltySetting.vue?vue&type=script&lang=js"
export * from "./royaltySetting.vue?vue&type=script&lang=js"
import style0 from "./royaltySetting.vue?vue&type=style&index=0&id=6a5b370c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports